import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface SiteInfo {
  id: string
  siteName: string
  description: string
  install_date?: string
  hierarchyStructure?: any
}

export interface SiteInfoState {
  isLoading: boolean
  loadingError: string | null
  siteInfo: SiteInfo | null
  httpStatus: number | null
}

export const initialState: SiteInfoState = {
  isLoading: true,
  loadingError: null,
  siteInfo: null,
  httpStatus: null
}

const siteInfoSlice = createSlice({
  name: 'siteManagementSiteInfo',
  initialState,
  reducers: {
    siteInfoLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        siteInfo: null,
        httpStatus: 0
      }
    },
    siteInfoUpdateAction: (state, action: PayloadAction<{ data: SiteInfo, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        siteInfo: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    siteInfoErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        siteInfo: null,
        httpStatus: action.payload.httpStatus
      }
    },
    siteInfoReset: () => initialState
  }
})

export const {
  siteInfoLoadingAction,
  siteInfoUpdateAction,
  siteInfoErrorAction,
  siteInfoReset
} = siteInfoSlice.actions

export default siteInfoSlice.reducer
